<template>
  <div :class="getClassInputContainer(field.type)"  :style="getStyleInputContainer(field.type)" >
    <div class="form-floating centrar-verticalmente" v-if="!ifType(field.type)">
        <input 
          :type="field.type"
          :class="['form-control', field.class, { 'is-invalid': errorMessages[field.id] }]"
          :id="field.id"
          :readonly="isReadonly(field.readonly)"
          :required="field.required"
          :name="name"
          v-model="localValue"
          :maxlength="field.maxlength || null"
          :placeholder="field.placeholder || field.label"
          @change="setValueToReg(field.id)"
        />
      <label :for="field.id">{{ getLabel(field) }}</label>
      <div class="invalid-feedback">
        {{ errorMessages[field.id] }}
      </div>
      <div v-if="field.msg" class="helpMessage" style="width: 100%;">
            <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
      </div>

    </div>
    <div v-if="field.type === 'checkbox'" class="centrar-verticalmente" style="min-height: 60px;">
      <component
        :is="dynamicComponents['checkboxInput']"
        :field="field"
        :name="name"
        :form-values="formValues"
        :error-messages="errorMessages"
        @update="setObjChangeToReg"
      ></component>
    </div>
    <div v-if="field.type === 'radio'" class="centrar-verticalmente" style="border-radius: 0.25rem; border: 1px solid #C0C0C0; min-height: 58px;">
      <component
        :is="dynamicComponents['radiobuttonInput']"
        :field="field"
        :name="name"
        :form-values="formValues"
        :error-messages="errorMessages"
        @update="setObjChangeToReg"
      ></component>
    </div>
    <div v-if="field.type === 'component'" class="centrar-verticalmente" style="border-radius: 0.25rem; border: 1px solid #C0C0C0; min-height: 58px;">
      <component 
        :is="dynamicComponents[field.component.id]"
        v-model:field-data="localValue"
        :form-data="formData"
        :form-values="formValues"
        :name="name"
        :field-name="field.id"
        :params="field.component"
        @input-change="setObjChangeToReg"
      ></component>
    </div>
      <div v-if="field.type === 'image'" class="centrar-verticalmente w-100" style="min-height: 58px;">
          <component 
            :is="dynamicComponents[field.component.id]"
            v-model="localValue"
            :form-data="formData"
            :form-values="formValues"
            :name="name"
            :field="field"
             @update="setObjChangeToReg"
          ></component>
    </div>
    <div class="form-floating centrar-verticalmente" v-if="field.type === 'textarea'">
      <textarea 
        :class="['form-control', field.class, { 'is-invalid': errorMessages[field.id] }]"
        :id="field.id"
        :name="name"
        :readonly="isReadonly(field.readonly)"
        :required="field.required"
        v-model="localValue"
        :placeholder="field.placeholder || field.label"
      ></textarea>
      <label :for="field.id">{{ getLabel(field) }}</label>
      <div class="invalid-feedback">
        {{ errorMessages[field.id] }}
      </div>
      <div v-if="field.msg" class="helpMessage" style="width: 100%;">
            <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
      </div>

    </div>
    <div v-if="field.type === 'label'" class="form-floating centrar-verticalmente">
      <div class="label-separator w-100">
        <div :class="field.class" >
          <icon v-if="field.iconLeft" :data="field.iconLeft" />
          {{ field.label }}
          <p v-if="field.html" v-html="field.html"></p>
        </div>
      </div>
      <div v-if="field.msg" class="helpMessage w-100">
        <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
      </div>
    </div>

    <div v-if="field.type === 'policy'" id="privacyPolicyCheck" class="form-floating centrar-verticalmente">
        <div v-if="field.type === 'checkbox'" class="centrar-verticalmente" style="border-radius: 0.25rem; border: 1px solid #C0C0C0; min-height: 60px;">
          <component
            :is="dynamicComponents['checkboxInput']"
            :field="field"
            :name="name"
            :form-values="formValues"
            :error-messages="errorMessages"
            @update="setObjChangeToReg"
          ></component>
        </div>
        <label class="custom-control-label" for="privacyPolicyCheck" :style="styleLabel(field,'')">Acepto la <a href="#" @click.prevent="openPolicyModal">Política de Tratamiento de Datos Personales</a></label>
    </div>
    <div v-if="field.type === 'select'" class="form-floating centrar-verticalmente">
      <div class="select-container">
        <select
          :class="['form-control', field.class, { 'is-invalid': errorMessages[field.id] }]"
          :id="field.id"
          :name="name"
          v-model="localValue"
          @change="setValueToReg(field.id)"
        >
          <option v-for="option in field.options" :key="option.value" :value="option.value" :selected="option.selected">{{ option.label }}</option>
        </select>
        <div class="dropdown-icon"><i class="fas fa-caret-down"></i></div>
      </div>
      <label :for="field.id" :style="styleLabel(field,'')">{{ field.label }}</label>
      <div class="invalid-feedback">
        {{ errorMessages[field.id] }}
      </div>
      <div v-if="field.msg" class="helpMessage" style="width: 100%;">
            <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
      </div>

    </div>
    <div v-if="isImageType(field)" class="p-0 m-0">
        <img v-if="formValues[field.id]" :name="name" :src="formValues[field.id]" :class="['image-preview', field.class]" :alt="field.label">
        <div v-if="field.msg" class="helpMessage" style="width: 100%;">
              <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true
    },
    formValues: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Object,
      required: true
    },
    dynamicComponents: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    name: { type: String},
    group: {
      type: Boolean,
    }
  },
  data() {
    return {
      localValue: this.formValues[this.field.id] || ''
    };
  },
  watch: {
    formValues: {
      handler(newVal) {
        this.localValue = newVal[this.field.id] || '';
      },
      deep: true
    }
  },
  mounted() {
    console.log("formField "+this.field.id+" = "+this.localValue)
  },
  methods: {
    getClassInputContainer(type) {
      if (this.formData.class && this.formData.class.types) {
        if (this.formData.class.types[type]) return `field-container ${this.formData.class.types[type]}`
      } 
      return "field-container"
    },
    getStyleInputContainer(type) {
      if (this.formData.styles && this.formData.styles.types) {
        if (this.formData.styles.types[type]) return `field-container ${this.formData.styles.types[type]}`
      } 
      return ""
    },
    styleLabel(field,str) {
      return str+field.styleLabel??"";
    },
    async setValueToReg(id) {
        //this.$emit('update:form-values', { [id]: this.localValue });
        if (this.field.onChange && this.field.action) {
          const apiData = {"field": id, "value": this.localValue};
          const st = await this.$api.call(this.field.action, apiData);
          if (!st.status) { 
              this.localValue == null;
          }
          else 
           this.$emit('setValueChangeToReg', { [id]: this.localValue });
        }
        else this.$emit('setValueChangeToReg', { [id]: this.localValue });

    },
    setObjChangeToReg(json) {
                   
       // debugger; // eslint-disable-line 
   
        this.$emit('setValueChangeToReg', json);
    },

    getLabel(field) {
      return field.required ? ( (field.label != "") ? field.label + "(*)" : "") : field.label;
    },
    isReadonly(ro) {
      return ro || false;
    },
    ifType(type) {
        
      const types = ['component', 'policy','checkbox', 'select', 'image', 'textarea', 'radio', "label"];
      return types.includes(type);
    },
    isImageType(field) {
      return field.type === 'image' && this.formValues[field.id];
    },
    updateFormValues(newValues) {
      this.$emit('update:form-values', newValues);
    }
  
  }
};
</script>

<style scoped>
.centrar-verticalmente {
  display: flex;
  align-items: center;
  height: 100%;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invalid-feedback {
  color: red;
  font-size: 10px;
}

.label-separator {
  margin-top: 15px;
  font-weight: bold;
}

.select-container {
  position: relative;
  min-width: 100%;
}

.select-container select {
  appearance: none; /* Remueve el estilo por defecto del navegador */
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 2.5rem; /* Espacio para el icono de triángulo */
}

.dropdown-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Evita que el icono interfiera con el clic del select */
  color: #999;
}

.dropdown-icon i {
  font-size: 1.2em;
}

.field-container {
  margin-bottom: 5px;
  padding-right: 0px;
}

.dropdown-icon:hover {
  color: #666;
}
</style>

